import {useTranslation} from "react-i18next";
import {Dropdown} from "./Dropdown";
import {
    CurrentBody,
    CurrentTable,
    DynamicInputTable,
    InputBody,
    InputTable
} from "./Input/DynamicInputTable";
import React from "react";

export default function TargetGroupInputTable({ targetGroups, onChange, currentTargetGroups = [],  }) {
    const {t} = useTranslation();
    
    const onDelete = (index) => {
        const updatedTargetGroups = currentTargetGroups.filter((_, i) => i !== index);
        onChange(updatedTargetGroups);
    }
    
    const onAdd = (value) => {
        let name = targetGroups.find(x => x.guid === value)?.name;
        const newTargetGroup = {name: name, id: value};

        const updatedTargetGroups = [...currentTargetGroups, newTargetGroup];
        onChange(updatedTargetGroups);
    }

    return <DynamicInputTable>
        <InputTable>
            <InputBody>
                <td>
                    <Dropdown options={targetGroups} valueProperty={"guid"}
                              property={"name"} placeholder={t("internalinfocontainer.selecttargetgroup")}
                              onChange={(value) => onAdd(value)}/>
                </td>
            </InputBody>
        </InputTable>
        <CurrentTable title={"Current target groups"}>
            <CurrentBody current={currentTargetGroups} onDelete={onDelete}>
                {(targetGroup) =><td key={targetGroup.name}>{targetGroup.name}</td>}
            </CurrentBody>
        </CurrentTable>
    </DynamicInputTable>
}